import { deleteHttp } from "../../common/api/apiShared";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { createElement } from "react";
import { Trans } from "react-i18next";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { BestPracticeDocumentTemplateViewModel } from "../BestPracticeDocumentTemplates.types";

export interface DeleteBestPracticeDocumentTemplateDialogProps {
    onDialogClose: () => void;
    onDeleted: () => void;
    selectedTemplate: BestPracticeDocumentTemplateViewModel;
}

export function useDeleteBestPracticeDocumentTemplateDialog(props: DeleteBestPracticeDocumentTemplateDialogProps) {
    const snackbar = useDotLegalSnackbar();

    const deleteMutation = useDotLegalMutation(deleteTemplate);

    const onDeleteClick = async () => {
        await deleteMutation.mutateAsync(props.selectedTemplate.id, {
            onSuccess: () => {
                snackbar.show(createElement(Trans, { i18nKey: "dataDeleted", values: { name: props.selectedTemplate.name } }));
                props.onDeleted();
            },
        });
    };

    return { onDeleteClick, inProgress: deleteMutation.isLoading };

    async function deleteTemplate(templateId: string) {
        return await deleteHttp(`/best-practice-document-templates/${templateId}`);
    }
}
